module.exports = __webpack_public_path__ + "static/media/halo-fix-image.03ae8770.svg";